import {HttpService} from "./http.service";

export class UserConsentsService {

  static create(hasSpinner = true): Promise<void> {
    return HttpService.post('/user-consents', {}, hasSpinner);
  }
}
